import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      if (window.location.pathname.startsWith('/admin') && 
          window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// NDA APIs
export const getNDAText = () => api.get('/nda-text');

export const submitNDA = async (formData) => {
  return api.post('/nda/submit', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Access Code APIs
export const validateAccessCode = (code) => api.post('/access/validate-code', { code });

export const getPricing = (code) => api.get(`/pricing?code=${code}`);

// Admin Auth APIs
export const adminLogin = (email, password) => 
  api.post('/admin/login', { email, password });

// Admin Request APIs
export const getAdminRequests = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.status) queryParams.append('status', params.status);
  if (params.search) queryParams.append('search', params.search);
  return api.get(`/admin/requests?${queryParams.toString()}`);
};

export const getAdminRequest = (id) => api.get(`/admin/requests/${id}`);

export const approveRequest = (id, customerId = null) => {
  const params = customerId ? `?customer_id=${customerId}` : '';
  return api.post(`/admin/requests/${id}/approve${params}`);
};

export const rejectRequest = (id, reason) => 
  api.post(`/admin/requests/${id}/reject`, { reason });

export const getDocumentUrl = (requestId, docType) => 
  `${API_BASE}/admin/documents/${requestId}/${docType}`;

// Admin Code APIs
export const getAdminCodes = () => api.get('/admin/codes');

export const disableCode = (id) => api.post(`/admin/codes/${id}/disable`);

export const enableCode = (id) => api.post(`/admin/codes/${id}/enable`);

// Admin Pricing APIs
export const getMasterPricing = () => api.get('/admin/master-pricing');

export const updateMasterPricing = (prices) => 
  api.put('/admin/master-pricing', { prices });

export const resetMasterPricing = () => 
  api.post('/admin/master-pricing/reset');

export const getCustomers = () => api.get('/admin/customers');

export const createCustomer = (name, email) => 
  api.post('/admin/customers', { name, email });

export const getCustomer = (id) => api.get(`/admin/customers/${id}`);

export const updateCustomerPricing = (id, data) => 
  api.put(`/admin/customers/${id}/pricing`, data);

export const deleteCustomer = (id) => api.delete(`/admin/customers/${id}`);

export const assignCustomerToCode = (codeId, customerId) => 
  api.post(`/admin/codes/${codeId}/assign-customer`, null, { 
    params: { customer_id: customerId || null } 
  });

export default api;
